export default __webpack_public_path__ + "static/media/MatiasGonzalez.58c4921d.png";